interface Endpoints {
  importarNota: string;
  relatorioInconsistencias: string;
  inconsistencialote: string;
  listarServicos: string;
  listarCnae: string;
  consultaCep: string;
  consultaPrestador: string;
  consultaTomador: string;
  consultaTomadorCpfCnpj: string;
  consultaServicoDesc: string;
  consultaServicoCod: string;
  descMunicipios: string;
  verificaIss: string;
  salvarIss: string;
  consultaServicoDescOuCod: string;
  recuperaNumNota: string;
  consultaTomadorIssEventual: string;
  salvarIssEventual: string;
  verificaIssEventual: string;
  recuperaNumNotaEventual: string;
  listarIssEventual: string;
  listarTomadorNomeCnpjCpf: string;
  relatorioNotaPdf: string;
  relatorioNotaXls: string;
  relatorioNotaCsv: string;
  listartodosisseventual: string;
  php: {
    previaGuia: string,
    gerarGuia: string;
    baixarGuia: string;
  };
}

export const ENDPOINTS: Endpoints = {
  importarNota: 'importacao-notafiscal-controller',
  relatorioInconsistencias: 'importacao-notafiscal-controller/inconsistenciaperiodo',
  inconsistencialote: 'importacao-notafiscal-controller/inconsistencialote',
  listarServicos: 'listarservicos',
  listarCnae: 'listarcnae',
  consultaCep: 'http://viacep.com.br/ws/',
  consultaPrestador: 'issretido/getprestadorissretido',
  consultaTomador: 'notaavulsa/recuperadadostomadorcuc',
  consultaTomadorCpfCnpj: 'notaavulsa/recuperadadostomados',
  consultaServicoDesc: 'bcservico/listarservicodescricao',
  consultaServicoCod: 'bcservico/listarservicocodigo',
  descMunicipios: 'credenciamento/autocompletemunicipiocompleto',
  verificaIss: 'issretido/existeissretidocomnumnotaseriecnpjprestador',
  salvarIss: 'issretido/gravaissretido',
  consultaServicoDescOuCod: 'bcservico/listarservicobycodigoedescricao',
  recuperaNumNota: 'issretido/recuperanovonumeronota',
  consultaTomadorIssEventual: 'isseventual/getprestadorisseventual',
  salvarIssEventual: 'isseventual/gravaissretido',
  verificaIssEventual: 'isseventual/existeissretidocomnumnotaseriecnpjtomador',
  recuperaNumNotaEventual: 'isseventual/recuperanovonumeronota',
  listarIssEventual: 'isseventual/listarisseventual',
  listarTomadorNomeCnpjCpf: 'isseventual/gettomadorisseventualbynomeoucpf',
  relatorioNotaPdf: 'isseventual/exportacao-iss-eventual-pdf',
  relatorioNotaXls: 'isseventual/exportacao-iss-eventual-xls',
  relatorioNotaCsv: 'isseventual/exportacao-iss-eventual-csv',
  listartodosisseventual: 'isseventual/listartodosisseventual',
  php: {
    previaGuia: 'http://homologacaowebphp.memory.com.br:81/issdeclarado/lancamento/untpreviaguia.php',
    gerarGuia:  'http://homologacaowebphp.memory.com.br:81/issdeclarado/lancamento/untgeraguia.php',
    baixarGuia: 'http://homologacaowebphp.memory.com.br:81/issdeclarado/guia/gerar_xml_guia.php'
  }
}